import { ReactNode, useEffect } from "react";
import { useViewMode } from "@/hooks/useViewMode";
import { useOrganization } from "@/hooks/useOrganization";
import { useAuth } from "@/hooks/useAuth";
import { supabase } from "@/integrations/supabase/client";
import DesktopLayout from "./DesktopLayout";
import MobileLayout from "./MobileLayout";

export default function AppLayout({ children }: { children: ReactNode }) {
  const { viewMode } = useViewMode();
  const { organization } = useOrganization();
  const { user } = useAuth();

  // Heartbeat for uptime monitoring
  useEffect(() => {
    if (!organization?.id || !user) return;

    const sendHeartbeat = async () => {
      await supabase.from("system_heartbeats").upsert({
        organization_id: organization.id,
        source: "web_admin",
        last_heartbeat: new Date().toISOString(),
        metadata: { user_agent: navigator.userAgent },
      }, { onConflict: "organization_id,source" }).then(() => {});
    };

    sendHeartbeat();
    const interval = setInterval(sendHeartbeat, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, [organization?.id, user]);

  if (viewMode === "desktop") {
    return <DesktopLayout>{children}</DesktopLayout>;
  }
  return <MobileLayout>{children}</MobileLayout>;
}
